import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import Lottie from "lottie-react";
import loadingAnim from "../../../../../../assets/animations/pleasewait.json";
import { StepBody, StepHeader, StepNav } from "./AiboxWizardParts";

const validateHost = (value) => {
    if (!value) return "";
    if (/^https?:\/\//i.test(value)) return "Do not include http:// or https://";
    if (/:\d+$/.test(value)) return "Do not include the port number in this field";
    return "";
};

const Field = ({ label, children, error }) => (
    <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        <label style={{ fontSize: "13px", fontWeight: 600, color: "#2d2d2d" }}>{label}</label>
        {children}
        {error && <small style={{ color: "#ee6d6d" }}>{error}</small>}
    </div>
);

export const AiboxStepLogin = ({ credentials, setCredentials, loginError, onLogin, onBack }) => {
    const set = (key) => (e) => setCredentials(prev => ({ ...prev, [key]: e.target.value }));
    const hostError = validateHost(credentials.hostName);
    const canLogin = credentials.hostName && credentials.port && credentials.username && credentials.password && !hostError;

    return (
        <>
            <StepHeader title="Ganz AiBox login" subtitle="Enter the AiBox's address and credentials" />
            <StepBody style={{ gap: "14px" }}>
                {loginError && (
                    <div style={{ padding: "10px 14px", borderRadius: "8px", background: "#fdecea", color: "#c0392b", fontSize: "13px" }}>
                        <i className="pi pi-exclamation-triangle" style={{ marginRight: "8px" }} />
                        {loginError}
                    </div>
                )}
                <Field label="IP address / hostname" error={hostError}>
                    <InputText value={credentials.hostName} onChange={set("hostName")}  />
                </Field>
                <Field label="Port">
                    <InputText value={credentials.port} onChange={set("port")}  keyfilter="int" />
                </Field>
                <Field label="Username">
                    <InputText value={credentials.username} onChange={set("username")} autoComplete="off" />
                </Field>
                <Field label="Password">
                    <Password value={credentials.password} onChange={set("password")} feedback={false} toggleMask inputStyle={{ width: "100%" }} style={{ width: "100%" }} autoComplete="new-password" />
                </Field>
            </StepBody>
            <StepNav onBack={onBack} onNext={onLogin} nextLabel="Log in" nextIcon="pi pi-sign-in" nextDisabled={!canLogin} />
        </>
    );
};

export const AiboxStepLoggingIn = ({ onClose }) => (
    <>
        <StepHeader title="Logging in" subtitle="Connecting to the Ganz AiBox, please wait..." />
        <StepBody style={{ alignItems: "center", justifyContent: "center" }}>
            <Lottie animationData={loadingAnim} loop style={{ width: 260, height: 260 }} />
        </StepBody>
        <StepNav onClose={onClose} />
    </>
);
